import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=182b21ef&scoped=true&lang=pug&"
import script from "./OrderDetails.vue?vue&type=script&lang=ts&"
export * from "./OrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=182b21ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b21ef",
  null
  
)

export default component.exports